import { apiRequest } from 'utils/request'
import { getPlatformFromRP } from 'utils/referenceParameter'
import { spApiData } from 'utils/supportParameter'
import createUri from 'utils/uriCreators'
import {
  compose,
  join,
  concat,
  reject,
  equals,
  split,
  omit,
  over,
  lensPath,
  set,
  not,
  isEmpty,
} from 'ramda'

export const getSupportParameter = ({ supportParameterNumber }) =>
  apiRequest({
    uri: createUri.supportParameter({ supportParameterNumber }),
    method: 'GET',
  })

export const saveSupportParameter = ({ supportParameter, rp = {} }) => {
  const rpType = not(isEmpty(rp)) ? getPlatformFromRP(rp) : undefined
  const { release, refParameterNumber } = rp

  return apiRequest({
    uri: `${createUri.supportParameter({
      supportParameterNumber: supportParameter.id,
    })}/update`,
    method: 'POST',
    body: {
      ...(refParameterNumber && { rpId: refParameterNumber }),
      ...(release && { rpRelease: release }),
      ...spApiData(supportParameter, rpType),
      // this data transformation should happen somewhere else upstream
      // the next best option is to have it happen in the handler, within the SupportParameterEditor container,
      // because the way that the async action creator handles finishing a stub doesn't allow for this sort of
      // transformation of additional arguments. Modifying that action combiner (for lack of a better term) to
      // accomodate that type of option doesn't seem in line with what it should be responsible for.
    },
  })
}

const prepForDuplication = compose(
  over(lensPath(['supportParameter']), omit(['status'])),
  set(lensPath(['supportParameter', 'timer_slot']), null),
  spApiData
)

export const duplicateSupportParameter = ({ originalSupportParameter }) =>
  apiRequest({
    uri: `${createUri.supportParameter({
      supportParameterNumber: originalSupportParameter.id,
    })}/duplicate`,
    method: 'POST',
    body: prepForDuplication(originalSupportParameter),
  })

const transformStatus = (string) =>
  compose(
    join(','),
    concat(['Active']),
    reject(equals('Pending Verification')),
    reject(equals('Design')),
    split(',')
  )(string)

export const activateSupportParameter = ({ supportParameter }) =>
  apiRequest({
    uri: `${createUri.supportParameter({
      supportParameterNumber: supportParameter.id,
    })}/activate`,
    method: 'POST',
    body: spApiData({
      ...supportParameter,
      status: transformStatus(supportParameter.status),
    }),
  })

export const batchActivateSupportParameters = ({ spIds }) =>
  apiRequest({
    uri: '/support-parameters/activate',
    method: 'POST',
    body: { spIds },
  })

export const getDefaultSupportParameterUri = ({ spType }) =>
  apiRequest({
    uri: `support-parameters/defaults/${spType}`,
  })
